import "./scripts/itinerary";
import "./styles/itinerary";

import ItinerariesResult from "./scripts/itineraries_result";

export default ItinerariesResult;
